var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C23.5 18.3514 18.3514 23.5 12 23.5C5.64864 23.5 0.5 18.3514 0.5 12C0.5 5.64864 5.64864 0.5 12 0.5C18.3514 0.5 23.5 5.64864 23.5 12Z",
    stroke: "#DCDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7282 11.6221C15.8305 10.7919 16.5446 9.47278 16.5446 7.98981C16.5446 5.48401 14.5059 3.44531 11.9999 3.44531C9.49414 3.44531 7.45544 5.48401 7.45544 7.98981C7.45544 9.47278 8.16937 10.7919 9.27167 11.6221C6.32037 12.7299 4.21411 15.5804 4.21411 18.9141H5.62036C5.62036 15.3962 8.4823 12.5345 12.0001 12.5345C15.5178 12.5345 18.3797 15.3962 18.3797 18.9141H19.7859C19.7858 15.5804 17.6797 12.7299 14.7282 11.6221ZM8.86169 7.98981C8.86169 6.25928 10.2694 4.85156 11.9999 4.85156C13.7305 4.85156 15.1382 6.25928 15.1382 7.98981C15.1382 9.72034 13.7305 11.1282 11.9999 11.1282C10.2694 11.1282 8.86169 9.72034 8.86169 7.98981Z",
    fill: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a5221425040d6d890255a3942baa5905.svg";
export { ForwardRef as ReactComponent };